import { render, staticRenderFns } from "./CategoryGames.vue?vue&type=template&id=936f59ce&lang=pug&"
import script from "./CategoryGames.vue?vue&type=script&lang=js&"
export * from "./CategoryGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielrubiocastillo/Documents/workspaces/emaraplay/lobby-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('936f59ce')) {
      api.createRecord('936f59ce', component.options)
    } else {
      api.reload('936f59ce', component.options)
    }
    module.hot.accept("./CategoryGames.vue?vue&type=template&id=936f59ce&lang=pug&", function () {
      api.rerender('936f59ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CategoryGames.vue"
export default component.exports